import React, { useState } from 'react'
import { AddContainer, Component4, NextFollowUpBox, NextFollowUpText, Texts, HeaderPart, FooterPart, SaveButton, CancelButton } from './Style'
import NumberInput from 'src/components/shared/Form/Number';
import { ReactComponent as CloseIcon } from '../../../../../../src/assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../../src/assets/images/add-square.svg';
import ButtonComponent from 'src/components/shared/Button';
import { palette, shadows } from 'src/config/theme.js';
import { alpha } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import useResponsive from 'src/components/hooks/useResponsive';
import { postFollowupRequest } from 'src/modules/app/store/appActions';
import useAppointmentDetails from '../../UseAppointmentDetails';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'src/utils/toast';
import InputComponent from 'src/components/shared/Form/Input';

function FollowUpTabForm({ onClose, fetchFollowUps }) {
    const { isMobile, isTablet, isDesktop } = useResponsive();
    const [followUpCount, setFollowUpCount] = useState(1);
    const [gapBetweenFollowUps, setGapBetweenFollowUps] = useState(0);
    const { PatientId, user, appointmentDetails, clinicId, appointmentId } = useAppointmentDetails();
    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        totalFollowup: Yup.string().required('followup are required'),
        days: Yup.string().required('template must be select')
    });

    const handleSubmit = async (values, { resetForm }) => {
        try {
            const followupData = {
                totalFollowup: values.totalFollowup,
                days: values.days,
                clinic: clinicId,
                patient: PatientId,
                user: user,
                tokenAppointment: appointmentId
            };

            const response = await new Promise((resolve, reject) => {
                dispatch(postFollowupRequest(followupData, resolve, reject));
            });

            console.log('Followup added successfully', response);
            toast.success(response.message)
            if (response?.newFollowup?.id && fetchFollowUps) {
                console.log("followup id", response?.newFollowUp?.id)
                fetchFollowUps();
            }
            onClose();

            resetForm();

        } catch (error) {
            console.log(error.followup || 'Failed to add followup', { variant: 'error' });
            toast.error(error)
        }
    };
    return (
        <>
            <Formik
                initialValues={{
                    totalFollowup: '',
                    days: ''
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleBlur, handleSubmit, handleChange, setFieldValue }) => (
                    <Form>

                        <HeaderPart>
                            Add Follow-ups
                            <CloseIcon width={isMobile || isTablet ? 18 : 24}
                                height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
                        </HeaderPart>
                        <AddContainer>
                            <Component4>
                                <Texts>How many Follow-ups?</Texts>
                                <InputComponent
                                    name="totalFollowup"
                                    value={values.totalFollowup}
                                    variant="outlined"
                                    placeholder="Enter number.."
                                    fullWidth
                                    multiline
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.totalFollowup && Boolean(errors.totalFollowup)}
                                    helperText={touched.totalFollowup && errors.totalFollowup}
                                    sx={{
                                        backgroundColor: palette.gery.white,
                                        boxShadow: shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            padding: '16px 18px',
                                            borderRadius: '12px',
                                            height: '52px',
                                            alignItems: 'flex-start',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                        },
                                    }}
                                />
                            </Component4>
                            <Component4>
                                <Texts>Gap between Follow-ups</Texts>
                                <InputComponent
                                    name="days"
                                    value={values.days}
                                    variant="outlined"
                                    placeholder="Enter days.."
                                    fullWidth
                                    multiline
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.days && Boolean(errors.days)}
                                    helperText={touched.days && errors.days}
                                    sx={{
                                        backgroundColor: palette.gery.white,
                                        boxShadow: shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            padding: '16px 18px',
                                            borderRadius: '12px',
                                            height: '52px',
                                            alignItems: 'flex-start',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                        },
                                    }}
                                />

                            </Component4>
                        </AddContainer>
                        <FooterPart >
                            <CancelButton
                                variant="none"
                                startIcon={<CloseIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} />}
                                onClick={onClose}
                            >
                                Cancel
                            </CancelButton>
                            <SaveButton
                                type="submit"
                                variant="outlined"
                                startIcon={<AddIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: palette.primary.main }} />}

                            // onClick={handleSubmit ? () => handleSubmit() : null}
                            >
                                Save
                            </SaveButton>
                        </FooterPart>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default FollowUpTabForm
